import { AuthBridge } from '../../../Common/AuthBridge';
import { AuthenticatedFetchErrorJSON } from '../../../Common/Definitions';
import { NetworkLocation, StoreConfiguration } from '../../../Common/TypeDefinitions';
import { HTTPFetchResponse, HeadersJson } from '../../../utils/http/Http';
import { NativeBridgeMapper } from '../NativeBridgeMapper';

export abstract class AuthBridgeBase extends NativeBridgeMapper implements AuthBridge {
	abstract gatewayAuthenticatedFetch(params: string): Promise<HTTPFetchResponse>;

	abstract getGatewayRoamingAccountsResponse(url: string): Promise<HTTPFetchResponse>;

	abstract setReferenceUriToGatewaySession(
		sessionUrl: URL,
		referenceUri: string
	): Promise<boolean>;

	abstract authFetch(
		method: string,
		url: string,
		headers: HeadersJson,
		body: string,
		referenceUri: string,
		allowCredUi: boolean,
		id?: string
	): Promise<HTTPFetchResponse>;

	abstract getStoreConfiguration(): Promise<StoreConfiguration>;

	abstract gatewayAuthenticatedFetchWrapper(
		params: string
	): Promise<HTTPFetchResponse | AuthenticatedFetchErrorJSON>;

	abstract authFetchWrapper(
		params: string
	): Promise<HTTPFetchResponse | AuthenticatedFetchErrorJSON>;

	abstract getNetworkLocation(params: string): Promise<NetworkLocation>;

	abstract getNetworkLocationForURL(params: string): Promise<NetworkLocation>;

	abstract evaluateNetworkLocationAndStoreConfiguration(params: string): Promise<void>;
}
